import { render } from "./FormularioAulaAvulsa.vue?vue&type=template&id=26f825ed&scoped=true"
import script from "./FormularioAulaAvulsa.vue?vue&type=script&lang=js"
export * from "./FormularioAulaAvulsa.vue?vue&type=script&lang=js"

import "./FormularioAulaAvulsa.vue?vue&type=style&index=0&id=26f825ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f825ed"]])

export default __exports__